'use client';

import { useState } from 'react';
import { Containers } from '@/components';

export default function DemoPage() {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Containers.Section
            el={
                <div className="w-full px-5 py-8 md:px-10 md:py-12 lg:px-[79px]">
                    <div className="mx-auto w-full">
                        <div className="relative w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                            {isLoading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
                                    <div className="flex flex-col items-center gap-3">
                                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
                                        <p className="text-sm text-gray-600">Loading calendar...</p>
                                    </div>
                                </div>
                            )}
                            <iframe
                                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ12aZQCT5gyzlw-Lpgovr0HZTh6w0O0cIjansm1DoSCZASc4svqz3cVZc4xsHzcCveyCe7tx3lv"
                                width="100%"
                                height="800"
                                frameBorder="0"
                                title="Book a Demo - Google Calendar"
                                className="block w-full min-h-[600px] md:min-h-[700px] lg:min-h-[800px]"
                                onLoad={() => setIsLoading(false)}
                                allow="calendar"
                            />
                        </div>
                    </div>
                </div>
            }
        />
    );
}

